import CONSTANTES from "../constantes";
export const actionGetOrdenes = (page,filtro) => ({
    type: CONSTANTES.GET_ORDENES,
    page,
    filtro
})
export const actionPutOrdenes = (ordenes,total) => ({
    type: CONSTANTES.PUT_ORDENES,
    ordenes,
    total
})

export const actionFiltroOrdenes= filtro => ({
    type: CONSTANTES.FILTRO_ORDENES,
    filtro,
})

export const actionGetOrden = idOrden => ({
    type: CONSTANTES.GET_ORDEN,
    idOrden,
})
export const actionPutOrden = orden => ({
    type: CONSTANTES.PUT_ORDEN,
    orden,
})

export const actionGetDetailOrdenComplete = idOrden => ({
    type: CONSTANTES.GET_DETAIL_ORDEN,
    idOrden,
})

export const actionPutDetailOrdenComplete = orden => ({
    type: CONSTANTES.PUT_DETAIL_ORDEN,
    orden,
})

export const actionRevisarOrden=(values)=>({
    type:CONSTANTES.REVISAR_ORDEN,
    values
})

export const actionPutRevisarOrden=(orden)=>({
    type:CONSTANTES.PUT_REVISAR_ORDEN,
    orden
})

export const actionGetHistorialOrdenes = (filter, fecha) => ({
    type: CONSTANTES.GET_HISTORIAL_ORDEN,
    filter,
    fecha
})
export const actionObtenerHistorialOrdenes = historial => ({
    type: CONSTANTES.OBTENER_HISTORIAL_ORDEN,
    historial,
})

